// extracted by mini-css-extract-plugin
export var tocpicsGobackBtn = "bF_fr";
export var topicsFilterContainer = "bF_fp";
export var topicsFilterWrapper = "bF_fq";